 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTACKNOWLEDGEMENTS from '@/components/Text/acknowledgements'
 import TEXTPART01 from '@/components/Text/part01'
 import TEXTINTRODUCTION from '@/components/Text/introduction'
 import TEXTCHAPTER01 from '@/components/Text/chapter01'
 import TEXTCHAPTER02 from '@/components/Text/chapter02'
 import TEXTCHAPTER03 from '@/components/Text/chapter03'
 import TEXTCHAPTER04 from '@/components/Text/chapter04'
 import TEXTCHAPTER05 from '@/components/Text/chapter05'
 import TEXTPART02 from '@/components/Text/part02'
 import TEXTINTRODUCTION01 from '@/components/Text/introduction01'
 import TEXTCHAPTER06 from '@/components/Text/chapter06'
 import TEXTCHAPTER07 from '@/components/Text/chapter07'
 import TEXTCHAPTER08 from '@/components/Text/chapter08'
 import TEXTCHAPTER09 from '@/components/Text/chapter09'
 import TEXTPART03 from '@/components/Text/part03'
 import TEXTINTRODUCTION02 from '@/components/Text/introduction02'
 import TEXTCHAPTER10 from '@/components/Text/chapter10'
 import TEXTCHAPTER11 from '@/components/Text/chapter11'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTABOUT from '@/components/Text/about'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/acknowledgements",
 			"name" : "Text/acknowledgements",
 			"component" : TEXTACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/Text/part01",
 			"name" : "Text/part01",
 			"component" : TEXTPART01
 		},
 		{
 			"path" : "/Text/introduction",
 			"name" : "Text/introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/chapter01",
 			"name" : "Text/chapter01",
 			"component" : TEXTCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js